export enum CoverageCreditIncentiveType {
  Fixed = "fixed",
  Percentage = "percentage",
}
